import { render } from "./AtorTable.vue?vue&type=template&id=260567d1"
import script from "./AtorTable.vue?vue&type=script&lang=js"
export * from "./AtorTable.vue?vue&type=script&lang=js"

import "./AtorTable.vue?vue&type=style&index=0&id=260567d1&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__